import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";


const ClaimsList = Loadable(
  lazy(() =>
    import("./ClaimsList").then(({ ClaimsList }) => ({
      default: ClaimsList,
    }))
  )
);

export const claimsRoutes = [
  {
    path: `/claims`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CLAIMS]}>
        <ClaimsList />
      </AuthorizedRoute>
    ),
  },
]